import { inject, Injectable } from '@angular/core';
import { IDataSeguro } from "../interfaces/seguros.interface";
import { IndexdbService } from '../../core/database/indexdb.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObtenerPrevisionService {
  private readonly indexDbService: IndexdbService = inject(IndexdbService);

  getPrevision(): Observable<IDataSeguro[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.previsiones ?? [])
    );
  }
}

